const addListener = (mediaQueryList, mediaQueryListChangeHandler) => {
    try {
        // Chrome, Firefox, and Safari 14+
        mediaQueryList.addEventListener('change', mediaQueryListChangeHandler);
    }
    catch (error) {
        // Older Safari and other browsers
        mediaQueryList.addListener(mediaQueryListChangeHandler);
    }
};
const removeListener = (mediaQueryList, mediaQueryListChangeHandler) => {
    try {
        // Chrome, Firefox, and Safari 14+
        mediaQueryList.removeEventListener('change', mediaQueryListChangeHandler);
    }
    catch (error) {
        // Older Safari and other browsers
        mediaQueryList.removeListener(mediaQueryListChangeHandler);
    }
};
const windowMatchMedia = {
    addListener,
    removeListener,
};
export default windowMatchMedia;
